module.exports = __webpack_public_path__ + "img/honor-right-2-3.e59da482.jpg";